import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useRegistrationQuote(eventId, inviteToken = "") {
  const [state, setState] = useState({ key: "", quote: null, error: "" });
  const [revision, setRevision] = useState(0);
  const key = `${eventId || ""}:${inviteToken}:${revision}`;
  useEffect(() => {
    let active = true;
    setState({ key, quote: null, error: "" });
    if (eventId) {
      api.get("/payments/quote", { params: { event_id: eventId, invite_token: inviteToken || undefined } })
        .then(({ data }) => { if (active) setState({ key, quote: data, error: "" }); })
        .catch(() => { if (active) setState({ key, quote: null, error: "Could not calculate your total. Please try again." }); });
    }
    return () => { active = false; };
  }, [eventId, inviteToken, key]);
  return {
    quote: state.key === key ? state.quote : null,
    error: state.key === key ? state.error : "",
    loading: !!eventId && (state.key !== key || (!state.quote && !state.error)),
    refresh: () => setRevision((value) => value + 1),
  };
}
